import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { Consultation, ConsultationFilters, CurrentConsultationResponse, TranscriptionsResponse } from "./";
import { toQueryParams } from "@shared/utils";
import { BackPagination, FrontPagination } from "@shared/components";
import { catchError, map, of, throwError } from "rxjs";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable({
    providedIn: "root",
})
export class ConsultationsService {
    url = `${environment.consultasURL}/consultations`;
    constructor(private http: HttpClient) {}

    getAll(pagination: FrontPagination, filters?: ConsultationFilters) {
        const params = toQueryParams({ ...pagination, ...filters });

        return this.http.get<BackPagination<Consultation>>(`${this.url}?${params}`);
    }

    finish(id: string) {
        return this.http.put(`${this.url}/${id}/finish`, {});
    }

    getById(id: string) {
        return this.http.get<Consultation>(`${this.url}/${id}`);
    }

    getTranscription(id: string) {
        return this.getTranscriptions(id);
    }

    getCurrentConsultation() {
        return this.http.get<CurrentConsultationResponse>(`${this.url}/current`).pipe(
            map((consultation) => this.isActiveConsultation(consultation) ? consultation : null),
            catchError((err: HttpErrorResponse) => {
                if (this.isNoCurrentConsultationError(err)) return of(null);
                return throwError(() => err);
            }),
        );
    }

    getTranscriptions(id: string) {
        return this.http.get<TranscriptionsResponse>(`${this.url}/${id}/transcriptions`).pipe(
            map((response) => Array.isArray(response) ? response : response.transcriptions || []),
        );
    }

    sendFeedback(payload: { consultationId: string; field: string; value: string }) {
        return this.http.post(`${this.url}/${payload.consultationId}/feedback`, payload);
    }

    savePhysicalExam(consultationId: string, exameFisico: string) {
        return this.http.put<void>(`${this.url}/${consultationId}/exame-fisico`, { exameFisico });
    }

    uploadVideo(videoFile: File) {
        const formData = new FormData();
        formData.append("file", videoFile);

        return this.http.post(`${this.url}/upload-video`, formData);
    }

    private isActiveConsultation(consultation?: CurrentConsultationResponse | null) {
        return !!consultation?.id && !consultation.finishedAt;
    }

    private isNoCurrentConsultationError(err: HttpErrorResponse) {
        const message = typeof err.error === "string" ? err.error : JSON.stringify(err.error || {});
        return message.toLowerCase().includes("nenhuma consulta encontrada");
    }
}
